import React from 'react'
import { Grid } from 'semantic-ui-react'
import InputField from '@commonComponents/formComponents/CustomInputField'
import { useCurrentShipmentType } from '@hooks/useCurrentShipmentType'

const MerchandiseSummary = ({
  id,
  dataSource: {
    commodityCode,
    convertedValue,
    grossMass,
    netMass,
    procedure,
    preference,
    originCountry,
    unitOfMeasurement,
    packageCount,
    taricAdditionalCodesList,
    nationalAdditionalCodesList,
  },
}) => {
  const isDisabled = true

  return (
    <Grid className='responsiveGridCss'>
      <Grid.Row>
        <Grid.Column width='1'>
          <InputField
            id={`HTS${id}`}
            type='text'
            label="HTS"
            value={commodityCode}
            clearInput={false}
            isDisabled={isDisabled}
          />
        </Grid.Column>
        <Grid.Column width='1'>
          <InputField
            id={`tarricAddCode${id}`}
            type='text'
            label="TARIC_ADD_CODE"
            value={
              taricAdditionalCodesList?.length > 0 &&
              taricAdditionalCodesList[taricAdditionalCodesList.length - 1]?.code || ''
            }
            clearInput={false}
            isDisabled={isDisabled}
          />
        </Grid.Column>
        <Grid.Column width='1'>
          <InputField
            id={`NationalAddCode${id}`}
            type='text'
            label="NATIONAL_ADD_CODE"
            value={
              nationalAdditionalCodesList?.length > 0 &&
              nationalAdditionalCodesList[nationalAdditionalCodesList.length - 1]?.code ||''
            }
            clearInput={false}
            isDisabled={isDisabled}
          />
        </Grid.Column>
        <Grid.Column width='1'>
          <InputField
            id={`EurValue${id}`}
            type='text'
            label="EUR_VALUE"
            value={convertedValue}
            clearInput={false}
            isDisabled={isDisabled}
          />
        </Grid.Column>
        <Grid.Column width='1'>
          <InputField
            id={`PROCEDURE${id}`}
            type='text'
            label="PROCEDURE"
            value={procedure}
            clearInput={false}
            isDisabled={isDisabled}
          />
        </Grid.Column>
        <Grid.Column width='1'>
          <InputField
            id={`PREFERENCE${id}`}
            type='text'
            label="PREFERENCE"
            value={preference}
            clearInput={false}
            isDisabled={isDisabled}
          />
        </Grid.Column>
        <Grid.Column width='1'>
          <InputField
            id={`origin${id}`}
            type='text'
            label="ORIGIN"
            value={originCountry}
            clearInput={false}
            isDisabled={isDisabled}
          />
        </Grid.Column>
        <Grid.Column width='1'>
          <InputField
            id={`grossMass${id}`}
            type='text'
            label="GROSS_MASS"
            value={grossMass}
            clearInput={false}
            isDisabled={isDisabled}
          />
        </Grid.Column>
        <Grid.Column width='1'>
          <InputField
            id={`netMass${id}`}
            type='text'
            label="NET_MASS_DMS"
            value={netMass}
            clearInput={false}
            isDisabled={isDisabled}
          />
        </Grid.Column>
        <Grid.Column width='1'>
          <InputField
            id={`qty${id}`}
            type='text'
            label="QTY"
            value={packageCount}
            clearInput={false}
            isDisabled={isDisabled}
          />
        </Grid.Column>
        <Grid.Column width='1'>
          <InputField
            id={`uom${id}`}
            type='text'
            label="UOM"
            value={unitOfMeasurement}
            clearInput={false}
            isDisabled={isDisabled}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  )
}
export default MerchandiseSummary
